var exports = {
  "panel": "ChatDetailsPanel.module__panel___amctWl",
  "tabs": "ChatDetailsPanel.module__tabs___amctWl",
  "tab": "ChatDetailsPanel.module__tab___amctWl",
  "tabOn": "ChatDetailsPanel.module__tabOn___amctWl",
  "fileMain": "ChatDetailsPanel.module__fileMain___amctWl",
  "download": "ChatDetailsPanel.module__download___amctWl",
  "more": "ChatDetailsPanel.module__more___amctWl",
  "count": "ChatDetailsPanel.module__count___amctWl",
  "body": "ChatDetailsPanel.module__body___amctWl",
  "todos": "ChatDetailsPanel.module__todos___amctWl",
  "add": "ChatDetailsPanel.module__add___amctWl",
  "empty": "ChatDetailsPanel.module__empty___amctWl",
  "files": "ChatDetailsPanel.module__files___amctWl",
  "file": "ChatDetailsPanel.module__file___amctWl",
  "tile": "ChatDetailsPanel.module__tile___amctWl",
  "thumb": "ChatDetailsPanel.module__thumb___amctWl",
  "tilePdf": "ChatDetailsPanel.module__tile_pdf___amctWl",
  "tileSheet": "ChatDetailsPanel.module__tile_sheet___amctWl",
  "tileImage": "ChatDetailsPanel.module__tile_image___amctWl",
  "tileOther": "ChatDetailsPanel.module__tile_other___amctWl",
  "fileText": "ChatDetailsPanel.module__fileText___amctWl",
  "fileName": "ChatDetailsPanel.module__fileName___amctWl",
  "fileMeta": "ChatDetailsPanel.module__fileMeta___amctWl",
  "detailsToggle": "ChatDetailsPanel.module__detailsToggle___amctWl",
  "inSheet": "ChatDetailsPanel.module__inSheet___amctWl",
};

__webpack_require__.r(module.exports = exports);
